import script from "./PopupPrivacy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupPrivacy.vue?vue&type=script&setup=true&lang=ts"

import "./PopupPrivacy.vue?vue&type=style&index=0&id=39ad7f3e&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ad7f3e"]])

export default __exports__